import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { get } from "lodash";

Vue.use(Vuex);

const genreList = [
  "Others",
  "Surrealism",
  "Fauvism",
  "Neo-Plasticism",
  "Futurism",
  "Cubism",
  "Expressionism",
  "Les Nabis",
  "Art Nouveau",
  "Pointillism",
  "Post-Impressionism",
  "Impressionism",
  "The Barbizon School",
  "Realism",
  "Symbolism",
  "Classicism",
  "The Pre-Raphaelite Brotherhood",
  "Romanticism",
  "Academic Art",
  "Neoclassicism",
  "Rococo Art",
  "Baroque Art",
  "Mannerism",
  "The Booming Renaissance",
  "The Northern Renaissance",
  "The Early Renaissance",
  "Gothic Art",
];

// const initialGenre = genreList[Math.floor(Math.random() * genreList.length)];
// Insist on my own aestentics, Neo-Plasticism -> Post-Impressionism
const initialGenre = genreList[3];

const museumList = [
  "A Casa de Serralves - Serralves",
  "Accademia Carrara, Bergamo",
  "Addison Gallery of American Art, Andover",
  "Akademie der bildenden Künste Wien",
  "Albright-Knox Art Gallery, Buffalo, NY",
  "Allen Memorial Art Museum, Oberlin College, Ohio",
  "Alte Pinakothek, Munich",
  "Amon Carter Museum, Fort Worth",
  "Armand Hammer Museum of Art, Los Angeles, California",
  "Arnot Art Museum, Elmira, NY",
  "Arp Museum Banhof Rolandseck",
  "Art Gallery of New South Wales, Sydney",
  "Art Gallery of Ontario",
  "Art Gallery of South Australia, Adelaide",
  "Asahi Beer Oyamazaki Villa Museum of Art",
  "Ashmolean Museum, Oxford, England",
  "Ateneum Art Museu",
  "Ateneumin Taidemuseo, Helsinki",
  "Atkinson Art Gallery and Library",
  "Auckland Art Gallery",
  "Baltimore Museum of Art",
  "Barber Institute of Fine-Arts at Birmingham",
  "Barnes Foundation, Merion, PA",
  "Basilica Papale di San Francesco di Assisi",
  "Basilica of Santa Croce",
  "Berardo Collection Museum",
  "Berkshire Museum (Pittsfield, assachusetts, United States)",
  "Berwick Museum and Art Gallery",
  "Beyeler Foundation",
  "Biblioteca Reale, Turin",
  "Bibliotheca Apostolica Vaticana",
  "Bilbao Fine Arts Museum",
  "Birmingham Museums and Art Gallery, Birmingham",
  "Bolton Museum and Art Gallery, Lancashire, UK",
  "Bridgeman Art Library at London",
  "Bridgestone Museum of Art, Tokyo",
  "British Museum. London",
  "Brooklyn Museum of Art, New York",
  "Brukenthal National Museum Sibiu",
  "Buckland Abbey",
  "Buffalo Bill Historical Center",
  "Burgtheater.Vienna",
  "Capitoline Museums",
  "Cappella Scrovegni, Padova, Italy",
  "Cappella dell’Arena, Padua",
  "Carnegie Institute, Museum of Art, Pittsburgh, PA",
  "Casino di Villa Boncompagni Ludovisi, Rome, Italy",
  "Cathedral of Bavo, Ghent",
  "Cathedral of Our Lady(Antwerp)",
  "Cathedrale Saint-Louis",
  "Centro de Arte Renia Sofia",
  "Cerasi Chapel, Santa Maria del Popolo, Rome",
  "Charlottenburg Palace",
  "Chateau Versailles",
  "Chiesa di San Domenico",
  "Chiesa di San Zaccaria",
  "Church of Pio Monte della Misericordia, Naples",
  "Church of Saint-Paul-Saint-Louis",
  "Château de Compiègne, France",
  "Château de Fontainebleau",
  "Cincinnati Art Museum",
  "City Museum & Art Gallery, Bristol",
  "Clark Art Institute, Williamstown",
  "Cleveland Museum of Art, Ohio",
  "Columbia Museum of Art South Carolina USA",
  "Columbus Museum",
  "Contarelli Chapel, San Luigi dei Francesi, Rome",
  "Convent of Santa Maria delle Grazie, Milan",
  "Convento di San Marco, Florence",
  "Corcoran Gallery of Art, Washington DC",
  "Courtauld Institute Galleries, London",
  "Courtland Institute Galleries",
  "Cummer Museum of Art & Gardens, Jacksonville",
  "Currier Gallery of Art, Manchester",
  "Czartoryski Museum, Kamionka",
  "Dali Museum (Museo Teatro), Figueres",
  "Dallas Museum of Art, Texas",
  "David Owsley Museum of Art",
  "Dayton Art Institute",
  "Delaware Art Museum, Wilmington, Delaware",
  "Denver Art Museum",
  "Des Moines Art Center",
  "Destroyed",
  "Detroit Institute of Arts, Detroit",
  "Diocesan Museum in Cortona",
  "Dixon Gallery & Gardens",
  "Dulwich Picture Gallery",
  "Duomo di Parma",
  "Duomo, Castelfranco Veneto",
  "E.G. Buhrle Foundation Collection, Zurich",
  "Ekaterinburg Museum of Fine Arts",
  "El Paso Museum of Art, El Paso, Texas, USA",
  "El Real Sitio de San Lorenzo de El Escorial",
  "Falmouth Art Gallery",
  "Ferens Art Gallery",
  "Fine Arts Museums of San Francisco",
  "Firenze, Galleria dell’Accademia",
  "Fitzwilliam Museum, Cambridge",
  "France, Dreux Musee d’Art et d’Histore de Dreux",
  "Frans Hals Museum, Haarlem",
  "Freer Gallery of Art",
  "Frick Collection, New York City",
  "Fukuoka City Art Gallery, Japan",
  "Fundacion Jodus Miro de Barcelona",
  "Gala - Salvador Dalí Foundation",
  "Galleria Borghese, Rome",
  "Galleria Doria Pamphilj, Rome",
  "Galleria Estense",
  "Galleria Nazionale delle Marche",
  "Galleria Nazionale d’Arte Moderna, Rome",
  "Galleria Nazionale, Parma",
  "Galleria Palatina (Palazzo Pitti), Florence",
  "Galleria Sabauda, Turin",
  "Galleria degli Uffizi in Florence",
  "Galleria dell’Accademia, Venice",
  "Galleria d’Arte Moderne, Venice",
  "Galleria d’arte moderna Ricci Oddi",
  "Gallerie dell’Accademia",
  "Gallerie dell’Accademia, Venice",
  "Gemaldegalerie Alte Meister",
  "Gemaldegalerie, Staatliche Museen, Berlin",
  "Gemäldegalerie Alte Meister",
  "Gibbes Museum of Art South Carolina USA",
  "Gilcrease Museum, Tulsa, Oklahoma",
  "Glasgow Art Gallery and Museum",
  "Glasgow Museums",
  "Grands panneaux muraux du musee des Beaux - Arts de Lyon, Palais Saint - Pierre",
  "Graphische Sammlung Albertina, Vienna",
  "Great Council Hall, Doge’s Palace, Venice",
  "Groeninge Museum, Bruges",
  "Groninger Museum",
  "Guildhall Art Gallery Imagebase, London",
  "Haags Gemeentemuseum voor Moderne Kunst, The Hague",
  "Haggin Museum, Stockton",
  "Hallwyl Museum",
  "Hamburger Kunsthalle",
  "Harvard University Art Museums, Cambridge",
  "Herakleidon Museu",
  "Herbert Art Gallery and Museum",
  "Hill-Stead Museum, Farmington, CT",
  "Hillwood Estate",
  "Hiroshima Museum of Art",
  "Hirshhorn Museum and Sculpture Garden",
  "Historisches Museum der Stadt Wien, Vienna",
  "Honolulu Museum of Art",
  "Hungarian National Gallery",
  "Hunter Museum of American Art, Chattanooga",
  "Hunterian Museum and Art Gallery",
  "Huntington Library, San Marino",
  "Huntington Museum",
  "Hôtel D’Orléans - Orléans, France",
  "Imperial War Museums",
  "Indiana University Art Museum",
  "Indianapolis Museum of Art, Indianapolis",
  "Isabella Steward Gardner Museum",
  "Isabella Stewart Gardner Museum",
  "Israel Museum, Jerusalem",
  "J. Paul Getty Museum, Los Angeles",
  "Joslyn Art Museum, Omaha, Nebraska",
  "Kenwood House. London",
  "Kimbell Art Museum, Fort Worth, Texas",
  "Klee Foundation. Bern",
  "Koninklijk Museum van Schoone Kunsten. Antwerp",
  "Krasnodar Territory Art Museum",
  "Kreeger Museum at Washington,DC",
  "Kunsthalle, Mannheim",
  "Kunsthalle. Bremen",
  "Kunsthaus Zug, Stiftung Sammlung Kamm",
  "Kunsthaus Zurich",
  "Kunsthistorisches Museum, Vienna",
  "Kunstmuseum Basel, Switzerland",
  "Kunstmuseum Bern",
  "Kunstmuseum Solothurn",
  "Kunstmuseum, Solothum, Swithzerland",
  "Kunstmuseum, Winterthur",
  "Kunstsammlung Nordrhein-Westfalen, Dusseldorf",
  "La Pinacoteca Nazionale di Bologna",
  "La Venaria Reale",
  "Lady Lever Art Gallery, Port Sunlight",
  "Lawrence University, Appleton",
  "Lazaro Galdiano Foundation Museums, Madrid",
  "Leiden, Stedelijk Museum De Lakenhal",
  "Leighton House Museum",
  "Leopold Museum Manfred Thumberger,Vienna",
  "Les Invalides",
  "Liechtenstein Museum",
  "Los Angeles County Museum of Art",
  "Lower Saxony State Museum",
  "Lucerne, Switzerland, Galerie Rosengart",
  "Lyman Allyn Art Museum",
  "MUCHA museum. Prague",
  "Manchester City Art Galleries, Manchester",
  "Mart Modern and Contemporary Art Museum of Trento and Rovereto",
  "Mauritshuis Royal Picture Gallery, The Hague",
  "Memorial Art Gallery, Rochester",
  "Memphis Brooks Museum of Art",
  "Merzbacher Kunststiftung, Switzerland",
  "Metropolitan Museum of Art, New York",
  "Michele and Donald D’Amour Museum of Fine Arts, Springfield, Massachusetts",
  "Mildred Lane Kemper Art Museum",
  "Milwaukee Art Museum",
  "Minneapolis Institute of Art, Minnesota",
  "Moderna Museet, Stockholm, Sweden",
  "Moderne Galerie, Dresden",
  "Moritzburg State Gallery,Halle",
  "Morohashi Museum of Modern Art",
  "MuMa - Musee d’art moderne Andre Malraux",
  "Munch Museum. Oslo",
  "Munson-Williams-Proctor Arts Institute",
  "Musee Cognacq-Jay at Paris",
  "Musee Conde. Chantilly",
  "Musee Fabre, Montpellier, Languedoc, France",
  "Musee Maillol",
  "Musee Marmottan, Paris",
  "Musee National Fernand Leger",
  "Musee National Picasso, Paris",
  "Musee National du Chateau de Malmaison，Rueil",
  "Musee National d’Art Moderne, Centre Georges Pompidou.",
  "Musee Royaux des Beaux-Arts, Brussels",
  "Musee Toulouse-Lautrec, Albi",
  "Musee de Gustave Moreau, Paris, France",
  "Musee de Peinture et Sculpture, Grenoble",
  "Musee de l’Orangerie, Paris",
  "Musee des Beaux-Arts d’Angers",
  "Musee des Beaux-Arts, Lyons",
  "Musee des Beaux-Arts, Marseille, France",
  "Musee des Beaux-Arts, Rouen",
  "Musee des Beaux-Arts, Tournai",
  "Musee des beaux-arts de La Rochelle, France",
  "Musee du Louvre. Paris",
  "Musee du Petit Palais, Paris",
  "Musee d’Art Moderne de Ville de Paris",
  "Musee d’Orsay. Paris",
  "Musee d’art moderne de Troyes",
  "Musees royaux des Beaux-Arts de Belgique, Brussels",
  "Musei Capitolini, Rome",
  "Musei di Strada Nuova",
  "Museo Horne, Florence",
  "Museo Poldi Pezzoli",
  "Museo de Arte Moderno",
  "Museo de Arte, Ponce, Puerto Rico",
  "Museo del Novecento",
  "Museo del Prado, Madrid",
  "Museo dell ’Opera di Santa Croce, Florence",
  "Museo della Porziuncola, Assisi",
  "Museo di Capodimonte",
  "Museo di Capodimonte, Naples, Italy",
  "Museo d’Arte Sacra della Val d’Arbia",
  "Museo d’arte della Svizzera italiana Lugano - LAC",
  "Museo il Correggio",
  "Museu Calouste Gulbenkian, Lisbon",
  "Museu Cau Ferrat",
  "Museu Nacional de Arte Antiga",
  "Museu Nacional d’Art de Catalunya",
  "Museu de Arte de São Paulo",
  "Museum Boijmans Van Beuningen, Rotterdam",
  "Museum Folkwang, Essen",
  "Museum Kampa",
  "Museum Kunstpalast Dusseldorf",
  "Museum Ludwig, Cologne",
  "Museum Mayer van den Bergh",
  "Museum Oskar Reinhart am Stadtgarten",
  "Museum Plantin-Moretus / Prentenkabinet - Antwerpen",
  "Museum at Forest-Lawn Memorial-Park, Glendale",
  "Museum of Applied Arts, Vienna, Austria",
  "Museum of Fine Art Gothenburg",
  "Museum of Fine Arts of Lyon",
  "Museum of Fine Arts, Boston",
  "Museum of Fine Arts, Budapest ( Szepmuveszeti Muzeum, Budapest )",
  "Museum of Fine Arts, Houston",
  "Museum of Fine Arts, Montreal",
  "Museum of Ixelles",
  "Museum of Modern Art, New York",
  "Museum of Modern and Contemporary Art of Trento and Rovereto",
  "Museum voor Schone Kunsten, Ghent",
  "Museumslandschaft of Hesse in Kassel",
  "Musée des Beaux-Arts de Nantes",
  "Musée archéologie nationale",
  "Musée de l’Armée",
  "Musée des Arts décoratifs",
  "Musée des Augustins de ToulouseLe",
  "Musée des Beaux-Arts de Nancy",
  "Musée des Beaux-Arts de Tours",
  "Musée des impressionnismes Giverny",
  "Musée d’art et d’histoire",
  "Musée d’art et d’histoire Baron Gérard",
  "Napoleonic museum",
  "Nardoni Gallery, Prague",
  "Nasjonalgalleriet Norway, Oslo",
  "National Gallery of Art at Washington,DC",
  "National Gallery of Australia",
  "National Gallery of Canada, Ottawa",
  "National Gallery of Modern and Contemporary Art",
  "National Gallery of Scotland, Edinburgh",
  "National Gallery of Victoria, Melbourne",
  "National Gallery, London",
  "National Maritime Museum, London",
  "National Museum in Belgrade",
  "National Museum of American Art, Washington",
  "National Museum of Art, Architecture and Design, Oslo, Norway",
  "National Museum of Fine Arts in Buenos Aires",
  "National Museum of Wales, Cardiff",
  "National Museum of Western Art, Tokyo",
  "National Museum of Women in the Arts",
  "National Museums & Galleries on Merseyside (NMGM)",
  "National Palace Museum",
  "National Portrait Gallery, London",
  "National Trust, Waddesdon Manor",
  "Nationalmuseum, Stockholm",
  "Nelson-Atkins Museum of Art, Kansas City",
  "Neue Galerie New York",
  "Neue Nationalgalerie - New National Gallery, Berlin",
  "Neue Pinakothek, Munich",
  "Neues Palais, Potsdam",
  "New-York Historical Society",
  "Newhouse Galleries, New York, NY",
  "Niedersächsisches Landesmuseum, Hannover",
  "Norfolk, Virginia Chrysler Museum of Art",
  "North Carolina Museum of Art, Raleigh",
  "Norton Museum of Art, West Palm Beach, Florida, USA",
  "Norton Simon Museum, Pasadena, California",
  "Ny Carlsberg-Glyptotek, Copenhagen",
  "Oesterreichische Galerie, Vienna",
  "Ohara Museum of Art, Kurashiki, Japan",
  "Old St. John’s Hospital",
  "Onze-Lieve-Vrouwekathedraal",
  "Ordrupgaard, Copenhagen",
  "Orientalist Museum, Doha",
  "Osaka City Museum of Fine Arts",
  "Oskar Reinhart collection Am Römerholz",
  "Palais des Beaux-Arts de Lille",
  "Palazzo Barberini, Rome",
  "Palazzo Bianco",
  "Palazzo Ducale di Mantova",
  "Palazzo Ducale, Venice, Italy",
  "Palazzo Vecchio, Firenze",
  "Paulista Museum",
  "Pera Museum",
  "Perth Museum and Art Gallery",
  "Philadelphia Museum of Art",
  "Phoenix Art Museum",
  "Picasso Museum Barcelona",
  "Picasso Museum Málaga",
  "Pinacoteca Ambrosiana, Milan",
  "Pinacoteca Giovanni e Marella Agnelli",
  "Pinacoteca Nazionale di Siena",
  "Pinacoteca Tosio Martinengo",
  "Pinacoteca Vaticana, Rome, Italy",
  "Pinacoteca di Brera, Milan, Italy",
  "Pinacoteca do Estado de Sao Paulo",
  "Polish National Museum, Warsaw",
  "Pomeranian State Museum",
  "Portland Art Museum, Oregon",
  "Private collection",
  "Pushkin Museum of Fine Arts, Moscow",
  "Reims, Musee des Beaux-Arts",
  "Residenzgalerie, Salzburg",
  "Reynolda House Museum of American Art",
  "Rhode Island School of Design, Providenc",
  "Richard Green Gallery, London",
  "Rijksmuseum Kroller-Mueller, Otterlo",
  "Rijksmuseum, Amsterdam",
  "Royal Academy of Arts, London",
  "Royal Academy of Fine Arts of San Fernando",
  "Royal Albert Memorial Museum",
  "Royal Collection, Buckingham Palace, London, England",
  "Royal Museum of Fine Arts Antwerp",
  "Royal Palace of Amsterdam",
  "Russell-Cotes Art Gallery and Museum",
  "S. Giorgio Maggiore, Venice",
  "SCAD Museum of Art",
  "Saarland Museum",
  "Sabauda Gallery",
  "Sala dell’Albergo, Scuola di San Rocco, Venice",
  "Salvador Dali Museum",
  "San Diego Museum of Art, CA",
  "San Francisco Museum of Modern Art",
  "San Zeno, Verona",
  "Santa Maria Gloriosa dei Frari, Venice",
  "Santa Maria Novella, Florence",
  "Santa Maria de Montserrat, Spain",
  "Santi Nazaro e Celso, Brescia",
  "Sassetti Chapel in Santa Trinita, Florence",
  "Schlossmuseum, Darmstadt",
  "Scottish National Gallery",
  "Scrovegni Chapel - Padua",
  "Scuola Grande di San Rocco",
  "Seattle Art Museum",
  "Shelburne Museum, VT, United States",
  "Sheldon Memorial Art Gallery at the University of Nebraska, Lincoln",
  "Sheldon Museum of Art",
  "Siena Cathedral, Siena, Italy",
  "Sir John Soane’s Museum, London",
  "Skokloster Castle",
  "Smith College Museum of Art, Northampton, MA",
  "Smithsonian American Art",
  "Smithsonian American Art Museum",
  "Solomon R. Guggenheim Museum, New York",
  "Southampton City Art Gallery, Southampton, England",
  "Sprengel Museum, Hannover",
  "St james palace",
  "St. Vitus Cathedral",
  "Staatliche Kunsthalle Karlsruhe",
  "Staatliche Kunstsammlungen Dresden",
  "Staatliche Museem Heidecksburg",
  "Staatsgalerie Stuttgart, Stuttgart",
  "Staatsgalerie moderner Kunst, Munich",
  "Stadel Museum, Frankfurt",
  "Stadtische Galerie im Lenbachhau, Munich",
  "Staedtische Galerie im Lenbachhaus, Germany",
  "State Hermitage Museum, St. Petersburg",
  "State Museum of New Western Art, Moscow",
  "State Tretyakov Gallery, Moscow",
  "Statens Museum for Kunst",
  "Stedelijk Museum Zwolle",
  "Stedelijk Museum, Amsterdam",
  "Stedelijk Van Abbe Museum",
  "Stoclet House",
  "Sudley House, Mossley Hill, Liverpool",
  "Tate Gallery. London",
  "Tel Aviv Museum of Art",
  "Terra Foundation for American Art",
  "The Andy Warhol Foundation, New York",
  "The Art Institute of Chicago",
  "The Art Museum, Princeton",
  "The Herzog Anton Ulrich Museum",
  "The Hugh Lane Gallery, Dublin",
  "The Jewish Museum (New York City)",
  "The Kawamura Memorial DIC Museum of Art",
  "The Laing Art Gallery",
  "The Menil Collection",
  "The Mesdag Collection, The Hague",
  "The Museum of Contemporary Art, Los Angeles",
  "The National Museum of Art, Architecture and Design, Norway",
  "The National Museum of Singapore",
  "The New Orleans Museum of Art",
  "The Phillips Collection, Washington, D.C.",
  "The Pierpont Morgan Library, New York City",
  "The Pollock-Krasner Foundation",
  "The Royal Pavilion",
  "The Saint Louis Art Museum, St. Louis",
  "The Salvador Dali Museum",
  "The State Russian Museum, St. Petersburg",
  "The Toledo Museum of Art",
  "The University of Michigan Museum of Art",
  "The Virginia Museum of Fine Arts, Richmond",
  "The Wallace Collection, London",
  "The Walters Art Museum",
  "Thomas Coram Foundation for Children, London",
  "Thurston royce gallery, Allentown",
  "Thyssen-Bornemisza Museum, Madrid",
  "Timken Museum of Art",
  "Tiroler Landesmuseum Ferdinandeum, Innsbruck",
  "Tokyo Fuji Art Museum",
  "Tokyo, Musée Marie Laurencin",
  "Towneley Hall Art Gallery, Burnley, England",
  "University of Glasgow",
  "University of Iowa Museum of Art",
  "Van Gogh Museum, Amsterdam",
  "Vatican Museums (Sistine Chapel), Vatican City",
  "Vicenza Musei Civici",
  "Victoria and Albert Museum, London",
  "Villa Farnesina, Rome",
  "Volta principale del Duomo di Pisa",
  "Von Der Heydt-Museum Wuppertal",
  "Wadsworth Atheneum Museum of Art, Hartford",
  "Walker Art Gallery, Liverpool",
  "Wallraf Richartz Museum, Cologne",
  "Walters Art Museum",
  "Washington, hanging in the White House",
  "Whitney Museum of American Art",
  "Williams College Museum of Art",
  "Worcester Art Museum, Worcester",
  "Wright Museum of Art at Beloit College, Beloit",
  "Yale Center for British Art, New Haven",
  "Yale University Art Gallery, New Haven",
  "Zentrum Paul Klee",
  "Zimmerli Art Museum at Rutgers University",
  "de Young Museum",
  "École nationale supérieure des Beaux-Arts",
];

const store = new Vuex.Store({
  state: {
    fullscreen: false,
    share: window.location.search.includes("share"),
    genre: initialGenre,
    museum: "Haags Gemeentemuseum voor Moderne Kunst, The Hague",
    searchResult: [],
    showCollection: false,
    museumList: museumList,
    showMuseumList: false,
    shrinkLeftMenu: true,
    hardwareBackActive: false,
    modalVisible: false, // related to hardwareBackActive event
    collectionResult: [],
    activeSinglePainting: {},
    imagesData: {
      Others: [],
      Surrealism: [],
      Fauvism: [],
      "Neo-Plasticism": [],
      Futurism: [],
      Cubism: [],
      Expressionism: [],
      "Les Nabis": [],
      "Art Nouveau": [],
      Pointillism: [],
      "Post-Impressionism": [],
      Impressionism: [],
      "The Barbizon School": [],
      Realism: [],
      Symbolism: [],
      Classicism: [],
      "The Pre-Raphaelite Brotherhood": [],
      Romanticism: [],
      "Academic Art": [],
      Neoclassicism: [],
      "Rococo Art": [],
      "Baroque Art": [],
      Mannerism: [],
      "The Booming Renaissance": [],
      "The Northern Renaissance": [],
      "The Early Renaissance": [],
      "Gothic Art": [],
    },
    leftHiddenImagesStack: {
      Others: [],
      Surrealism: [],
      Fauvism: [],
      "Neo-Plasticism": [],
      Futurism: [],
      Cubism: [],
      Expressionism: [],
      "Les Nabis": [],
      "Art Nouveau": [],
      Pointillism: [],
      "Post-Impressionism": [],
      Impressionism: [],
      "The Barbizon School": [],
      Realism: [],
      Symbolism: [],
      Classicism: [],
      "The Pre-Raphaelite Brotherhood": [],
      Romanticism: [],
      "Academic Art": [],
      Neoclassicism: [],
      "Rococo Art": [],
      "Baroque Art": [],
      Mannerism: [],
      "The Booming Renaissance": [],
      "The Northern Renaissance": [],
      "The Early Renaissance": [],
      "Gothic Art": [],
    },
    rightHiddenImagesStack: {
      Others: [],
      Surrealism: [],
      Fauvism: [],
      "Neo-Plasticism": [],
      Futurism: [],
      Cubism: [],
      Expressionism: [],
      "Les Nabis": [],
      "Art Nouveau": [],
      Pointillism: [],
      "Post-Impressionism": [],
      Impressionism: [],
      "The Barbizon School": [],
      Realism: [],
      Symbolism: [],
      Classicism: [],
      "The Pre-Raphaelite Brotherhood": [],
      Romanticism: [],
      "Academic Art": [],
      Neoclassicism: [],
      "Rococo Art": [],
      "Baroque Art": [],
      Mannerism: [],
      "The Booming Renaissance": [],
      "The Northern Renaissance": [],
      "The Early Renaissance": [],
      "Gothic Art": [],
    },
    lastLeftPushImagesRecords: [],
    lastRightPushImagesRecords: [],
  },

  mutations: {
    TOGGLE_FULLSCREEN(state) {
      state.fullscreen = !state.fullscreen;
    },

    UPDATE_HARDWARE_BACK_ACTIVE(state, data) {
      state.hardwareBackActive = data;
    },

    UPDATE_MODAL_VISIBLE(state, data) {
      state.modalVisible = data;
    },

    UPDATE_SHRINK_LEFTMENU(state, data) {
      state.shrinkLeftMenu = data;
    },

    UPDATE_ACTIVE_SINGLE_PAINTING(state, painting) {
      state.activeSinglePainting = painting;
    },

    UPDATE_SEARCH_RESULT(state, data) {
      state.searchResult = data;
    },

    TOGGLE_SHOW_MUSEUM_LIST(state, data) {
      state.showMuseumList = data;
    },

    TOGGLE_SHOW_COLLECTION(state) {
      state.showCollection = !state.showCollection;
    },

    UPDATE_COLLECTION_RESULT(state, data) {
      state.collectionResult = data;
    },

    SWITCH_GENRE(state, data) {
      let { key } = data;
      state.genre = key;
    },
    SWITCH_MUSEUM(state, data) {
      let { key } = data;
      state.museum = key;
    },
    INITIALIZE_IMAGES_DATA(state, data) {
      let { key, images } = data;
      state.imagesData[key] = images;
    },
    INITIALIZE_LEFT_HIDDEN_IMAGES_STACK(state, data) {
      let { key, images } = data;
      state.leftHiddenImagesStack[key] = images;
    },
    INITIALIZE_RIGHT_HIDDEN_IMAGES_STACK(state, data) {
      let { key, images } = data;
      state.rightHiddenImagesStack[key] = images;
    },
    LEFT_UNSHIFT_IMAGES_DATA(state, data) {
      let { key, images } = data;
      if (Array.isArray(state.leftHiddenImagesStack[key])) {
        images.forEach((image) => {
          state.leftHiddenImagesStack[key].unshift(image);
        });
      } else {
        throw new Error("Mutation LEFT_UNSHIFT_IMAGES_DATA failed");
      }
    },
    RIGHT_UNSHIFT_IMAGES_DATA(state, data) {
      let { key, images } = data;
      if (Array.isArray(state.rightHiddenImagesStack[key])) {
        images.forEach((image) => {
          state.rightHiddenImagesStack[key].unshift(image);
        });
      } else {
        throw new Error("Mutation RIGHT_UNSHIFT_IMAGES_DATA failed");
      }
    },
    LEFT_PUSH_IMAGES_DATA(state, data) {
      let { key, images } = data;
      if (Array.isArray(state.leftHiddenImagesStack[key])) {
        images.forEach((image) => {
          state.leftHiddenImagesStack[key].push(image);
        });
      } else {
        throw new Error("Mutation LEFT_PUSH_IMAGES_DATA failed");
      }
    },
    RIGHT_PUSH_IMAGES_DATA(state, data) {
      let { key, images } = data;
      if (Array.isArray(state.rightHiddenImagesStack[key])) {
        images.forEach((image) => {
          state.rightHiddenImagesStack[key].push(image);
        });
      } else {
        throw new Error("Mutation RIGHT_PUSH_IMAGES_DATA failed");
      }
    },
    LEFT_HIDDEN_IMAGES_STACK_POP(state, data) {
      let { key } = data;
      state.leftHiddenImagesStack[key].pop();
    },
    RIGHT_HIDDEN_IMAGES_STACK_POP(state, data) {
      let { key } = data;
      state.rightHiddenImagesStack[key].pop();
    },
    LEFT_HIDDEN_IMAGES_STACK_SHIFT(state, data) {
      let { key } = data;
      state.leftHiddenImagesStack[key].shift();
    },
    RIGHT_HIDDEN_IMAGES_STACK_SHIFT(state, data) {
      let { key } = data;
      state.rightHiddenImagesStack[key].shift();
    },
    UPDATE_LAST_LEFT_PUSH_IMAGES_RECORDS(state, data) {
      state.lastLeftPushImagesRecords = data;
    },
    UPDATE_LAST_RIGHT_PUSH_IMAGES_RECORDS(state, data) {
      state.lastRightPushImagesRecords = data;
    },
  },

  actions: {
    toggleFullscreen({ commit }) {
      commit("TOGGLE_FULLSCREEN");
    },

    updateHardwareBackActive({ commit }, data) {
      commit("UPDATE_HARDWARE_BACK_ACTIVE", data);
    },

    updateModalVisible({ commit }, data) {
      commit("UPDATE_MODAL_VISIBLE", data);
    },

    updateShrinkLeftMenu({ commit }, data) {
      commit("UPDATE_SHRINK_LEFTMENU", data);
    },

    updateActiveSinglePainting({ commit }, painting) {
      commit("UPDATE_ACTIVE_SINGLE_PAINTING", painting);
    },

    async fetchSinglePainting({ commit }, data) {
      let { index } = data;
      let { data: paintingInfo } = await axios.get(
        `https://api.boost-art.net/v1/painting?index=${index}`
      );
      commit("UPDATE_ACTIVE_SINGLE_PAINTING", paintingInfo["data"][0]);
      return paintingInfo["data"][0];
    },

    async fetchSearchResult({ commit }, searchString) {
      const config = {
        method: "get",
        url: `https://api.boost-art.net/v1/search?q=${searchString}`,
        headers: {},
      };

      const response = await axios(config).catch((err) => {
        throw new Error(err);
      });

      commit("UPDATE_SEARCH_RESULT", get(response.data, "data", []));
      return "success";
    },

    toggleShowMuseumList({ commit }, data) {
      commit("TOGGLE_SHOW_MUSEUM_LIST", data);
    },

    toggleShowCollection({ commit }) {
      commit("TOGGLE_SHOW_COLLECTION");
    },

    /**
     Local Collection Template: 
      {
        "userLikedImageIdList": [],
        "userLikedImageObjectList": []
      }
     */

    // async fetchCollectionResult({ commit }, token) {
    //   const config = {
    //     method: "post",
    //     url: `https://api.boost-art.net/v1/getCollection`,
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     data: {
    //       "boost-art-net-token": token,
    //     },
    //     withCredentials: true,
    //   };

    //   const response = await axios(config).catch((err) => {
    //     throw new Error(err);
    //   });

    //   commit("UPDATE_COLLECTION_RESULT", get(response.data, "data", []));
    //   return "success";
    // },

    async fetchCollectionResult({ commit }) {
      const localCollectionResultObject =
        JSON.parse(window.localStorage.getItem("local-collection-result")) ||
        {};

      commit(
        "UPDATE_COLLECTION_RESULT",
        localCollectionResultObject["userLikedImageObjectList"]
      );

      return "success";
    },

    // async addLikeToCollection({ commit }, { token, index }) {
    //   const config = {
    //     method: "post",
    //     url: `https://api.boost-art.net/v1/like`,
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     data: {
    //       "boost-art-net-token": token,
    //       "like-id": index,
    //     },
    //     withCredentials: true,
    //   };

    //   const response = await axios(config).catch((err) => {
    //     throw new Error(err);
    //   });

    //   // false operation on purpose
    //   commit(
    //     "UPDATE_COLLECTION_RESULT",
    //     get(this.state, "collectionResult", [])
    //   );

    //   return response?.message === "User like status OK" ? "success" : "";
    // },

    async addLikeToCollection({ commit }, { index }) {
      // The first time to set "local-collection-result"
      if (!window.localStorage.getItem("local-collection-result")) {
        const config = {
          method: "get",
          url: `https://api.boost-art.net/v1/painting?index=${index}`,
          headers: {
            "Content-Type": "application/json",
          },
        };

        const response = await axios(config).catch((err) => {
          throw new Error(err);
        });

        const localCollectionResultObject = {
          userLikedImageIdList: [index],
          userLikedImageObjectList: response?.data?.data,
        };

        window.localStorage.setItem(
          "local-collection-result",
          JSON.stringify(localCollectionResultObject)
        );

        commit(
          "UPDATE_COLLECTION_RESULT",
          localCollectionResultObject["userLikedImageObjectList"]
        );
      } else {
        const existingLocalCollectionResultObject = JSON.parse(
          window.localStorage.getItem("local-collection-result")
        );

        const config = {
          method: "get",
          url: `https://api.boost-art.net/v1/painting?index=${index}`,
          headers: {
            "Content-Type": "application/json",
          },
        };

        const response = await axios(config).catch((err) => {
          throw new Error(err);
        });

        const newUserLikedImageIdList = [
          // depulicate
          ...new Set([
            index,
            ...existingLocalCollectionResultObject["userLikedImageIdList"],
          ]),
        ];

        const newUserLikedImageObjectList =
          // depulicate
          [
            ...response?.data?.data,
            ...existingLocalCollectionResultObject["userLikedImageObjectList"],
          ].filter((el) =>
            newUserLikedImageIdList.includes(el["Painting_Index"])
          );

        const localCollectionResultObject = {
          userLikedImageIdList: newUserLikedImageIdList,
          userLikedImageObjectList: newUserLikedImageObjectList,
        };

        window.localStorage.setItem(
          "local-collection-result",
          JSON.stringify(localCollectionResultObject)
        );

        commit(
          "UPDATE_COLLECTION_RESULT",
          localCollectionResultObject["userLikedImageObjectList"]
        );
      }

      return "success";
    },

    // async removeLikeFromCollection({ commit }, { token, index }) {
    //   const config = {
    //     method: "post",
    //     url: `https://api.boost-art.net/v1/dislike`,
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     data: {
    //       "boost-art-net-token": token,
    //       "dislike-id": index,
    //     },
    //     withCredentials: true,
    //   };

    //   const response = await axios(config).catch((err) => {
    //     throw new Error(err);
    //   });

    //   // false operation on purpose
    //   commit(
    //     "UPDATE_COLLECTION_RESULT",
    //     get(this.state, "collectionResult", [])
    //   );

    //   return response?.message === "User dislike status OK" ? "success" : "";
    // },

    async removeLikeFromCollection({ commit }, { index }) {
      const existingLocalCollectionResultObject = JSON.parse(
        window.localStorage.getItem("local-collection-result")
      );

      if (existingLocalCollectionResultObject) {
        const localCollectionResultObject = {
          userLikedImageIdList: existingLocalCollectionResultObject[
            "userLikedImageIdList"
          ].filter((el) => el !== index),
          userLikedImageObjectList: existingLocalCollectionResultObject[
            "userLikedImageObjectList"
          ].filter((el) => el["Painting_Index"] !== index),
        };

        window.localStorage.setItem(
          "local-collection-result",
          JSON.stringify(localCollectionResultObject)
        );

        commit(
          "UPDATE_COLLECTION_RESULT",
          localCollectionResultObject["userLikedImageObjectList"]
        );
      }

      return "success";
    },

    clearSearchResult({ commit }) {
      commit("UPDATE_SEARCH_RESULT", []);
    },

    clearCollectionResult({ commit }) {
      commit("UPDATE_COLLECTION_RESULT", []);
    },

    switchGenre({ commit }, key) {
      const payLoads = {
        key: key,
      };
      commit("SWITCH_GENRE", payLoads);
    },

    switchMuseum({ commit }, key) {
      const payLoads = {
        key: key,
      };
      commit("SWITCH_MUSEUM", payLoads);
    },

    initializeMuseumData({ commit }, key) {
      const config = {
        method: "get",
        url: `https://api.boost-art.net/v1/paintings?museum=${key}&counts=7`,
        headers: {},
      };

      return new Promise((resolve, reject) => {
        axios(config)
          .then(function (response) {
            const payLoads = {
              key: "Others",
              images: get(response.data, "data"),
            };
            commit("INITIALIZE_IMAGES_DATA", payLoads);
            commit("INITIALIZE_LEFT_HIDDEN_IMAGES_STACK", {
              key: "Others",
              images: [],
            });
            commit("INITIALIZE_RIGHT_HIDDEN_IMAGES_STACK", {
              key: "Others",
              images: [],
            });
            resolve("success");
            // console.log(JSON.stringify(response.data));
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    },

    leftUnshiftMuseumData({ commit }, key) {
      const config = {
        method: "get",
        url: `https://api.boost-art.net/v1/paintings?museum=${key}&counts=5`,
        headers: {},
      };

      return new Promise((resolve, reject) => {
        axios(config)
          .then(function (response) {
            console.log("left fill");
            // store the last four for later use
            const payLoads = {
              key: "Others",
              images: get(response.data, "data").slice(0, -1),
            };

            // pop the first one for immediate rendering
            const popData = {
              key: "Others",
              images: get(response.data, "data").slice(-1),
            };

            commit("LEFT_UNSHIFT_IMAGES_DATA", payLoads);
            commit(
              "UPDATE_LAST_LEFT_PUSH_IMAGES_RECORDS",
              get(response.data, "data").map((el) => el["Painting_Index"])
            );
            resolve(popData);
            // console.log(JSON.stringify(response.data));
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    },

    rightPushMuseumData({ commit }, key) {
      const config = {
        method: "get",
        url: `https://api.boost-art.net/v1/paintings?museum=${key}&counts=5`,
        headers: {},
      };

      return new Promise((resolve, reject) => {
        axios(config)
          .then(function (response) {
            console.log("right fill");
            // store the last four for later use
            const payLoads = {
              key: "Others",
              images: get(response.data, "data").slice(0, -1),
            };

            // pop the first one for immediate rendering
            const popData = {
              key: "Others",
              images: get(response.data, "data").slice(-1),
            };

            commit("RIGHT_PUSH_IMAGES_DATA", payLoads);
            commit(
              "UPDATE_LAST_RIGHT_PUSH_IMAGES_RECORDS",
              get(response.data, "data").map((el) => el["Painting_Index"])
            );
            resolve(popData);
            // console.log(JSON.stringify(response.data));
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    },

    initializeImagesData({ commit }, key) {
      const config = {
        method: "get",
        url: `https://api.boost-art.net/v1/paintings?style=${key}&counts=7`,
        headers: {},
      };

      return new Promise((resolve, reject) => {
        axios(config)
          .then(function (response) {
            const payLoads = {
              key: get(response.data, "style"),
              images: get(response.data, "data"),
            };
            commit("INITIALIZE_IMAGES_DATA", payLoads);
            resolve("success");
            // console.log(JSON.stringify(response.data));
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    },

    leftUnshiftImagesData({ commit }, key) {
      const config = {
        method: "get",
        url: `https://api.boost-art.net/v1/paintings?style=${key}&counts=5&lastPushImagesRecords=${JSON.stringify(
          this.state.lastLeftPushImagesRecords
        ).slice(1, -1)}`,
        // like "VanGogh252","Cezanne246"
        // State management to prevent duplicate records in subsequent requests
        // Context: https://github.com/Leslie-Wong-H/Boost-Art-RestAPI/issues/35
        headers: {},
      };

      return new Promise((resolve, reject) => {
        axios(config)
          .then(function (response) {
            console.log("left fill");
            // store the last four for later use
            const payLoads = {
              key: get(response.data, "style"),
              images: get(response.data, "data").slice(0, -1),
            };

            // pop the first one for immediate rendering
            const popData = {
              key: get(response.data, "style"),
              images: get(response.data, "data").slice(-1),
            };

            commit("LEFT_UNSHIFT_IMAGES_DATA", payLoads);
            commit(
              "UPDATE_LAST_LEFT_PUSH_IMAGES_RECORDS",
              get(response.data, "data").map((el) => el["Painting_Index"])
            );
            resolve(popData);
            // console.log(JSON.stringify(response.data));
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    },

    rightPushImagesData({ commit }, key) {
      const config = {
        method: "get",
        url: `https://api.boost-art.net/v1/paintings?style=${key}&counts=5&lastPushImagesRecords=${JSON.stringify(
          this.state.lastRightPushImagesRecords
        ).slice(1, -1)}`,
        // like "VanGogh252","Cezanne246"
        // State management to prevent duplicate records in subsequent requests
        // Context: https://github.com/Leslie-Wong-H/Boost-Art-RestAPI/issues/35
        headers: {},
      };

      return new Promise((resolve, reject) => {
        axios(config)
          .then(function (response) {
            console.log("right fill");
            // store the last four for later use
            const payLoads = {
              key: get(response.data, "style"),
              images: get(response.data, "data").slice(0, -1),
            };

            // pop the first one for immediate rendering
            const popData = {
              key: get(response.data, "style"),
              images: get(response.data, "data").slice(-1),
            };

            commit("RIGHT_PUSH_IMAGES_DATA", payLoads);
            commit(
              "UPDATE_LAST_RIGHT_PUSH_IMAGES_RECORDS",
              get(response.data, "data").map((el) => el["Painting_Index"])
            );
            resolve(popData);
            // console.log(JSON.stringify(response.data));
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    },

    leftHiddenImagesStackPop({ commit }, key) {
      const payLoads = {
        key: key,
      };
      commit("LEFT_HIDDEN_IMAGES_STACK_POP", payLoads);
    },

    rightHiddenImagesStackPop({ commit }, key) {
      const payLoads = {
        key: key,
      };
      commit("RIGHT_HIDDEN_IMAGES_STACK_POP", payLoads);
    },

    leftHiddenImagesStackShift({ commit }, key) {
      const payLoads = {
        key: key,
      };
      commit("LEFT_HIDDEN_IMAGES_STACK_SHIFT", payLoads);
    },

    rightHiddenImagesStackShift({ commit }, key) {
      const payLoads = {
        key: key,
      };
      commit("RIGHT_HIDDEN_IMAGES_STACK_SHIFT", payLoads);
    },
  },

  getters: {
    getFullscreen(state) {
      return state.fullscreen;
    },

    getShare(state) {
      return state.share;
    },

    getHardwareBackActive(state) {
      return state.hardwareBackActive;
    },

    getModalVisible(state) {
      return state.modalVisible;
    },

    getShrinkLeftMenu(state) {
      return state.shrinkLeftMenu;
    },

    getActiveSinglePainting(state) {
      return state.activeSinglePainting;
    },

    getSearchResult(state) {
      return state.searchResult;
    },

    getMuseumList(state) {
      return state.museumList;
    },

    getShowMuseumList(state) {
      return state.showMuseumList;
    },

    getShowCollection(state) {
      return state.showCollection;
    },

    getCollectionResult(state) {
      return state.collectionResult;
    },

    getGenre(state) {
      return state.genre;
    },

    getMuseum(state) {
      return state.museum;
    },

    getImagesData(state) {
      return state.imagesData;
    },

    getLeftHiddenImagesStack(state) {
      return state.leftHiddenImagesStack;
    },

    getRightHiddenImagesStack(state) {
      return state.rightHiddenImagesStack;
    },
  },
});

export default store;
